
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductContract } from '@/types';
import { ContractLink } from '@/components/Shared';
import ProductDetailsIcon from '@/assets/icons/icn-product-details.svg';
import ClockIcon from '@/assets/icons/icn-clock.svg';
import ReplacedIcon from '@/assets/icons/icn-replaced.svg';

@Component({
  components: {
    ProductDetailsIcon,
    ClockIcon,
    ContractLink,
    ReplacedIcon,
  },
})
export default class ProductDetails extends Vue {
  @Prop() public contracts: ProductContract;
  @Prop() public warrantyEndDate: string;
  @Prop() public replaced: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductDetails/ProductDetails.vue